import React, { useState } from "react";
import { useData } from "../../../context/DataContext";
import ImageUploadField from "../../../utils/ImageUploadField";
import { confirmDelete, successToast } from "../../../utils/dialog";

export default function AdminTestimonials() {
  const { testimonials, addTestimonial, updateTestimonial, deleteTestimonial } = useData();

  const [newTestimonial, setNewTestimonial] = useState({
    name: "",
    role: "",
    text: "",
    avatar: "",
  });

  const [file, setFile] = useState(null); // File for upload
  const [editingTestimonial, setEditingTestimonial] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewTestimonial((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]); // Set the selected file
  };

  const handleAddTestimonial = async () => {
    if (newTestimonial.name && newTestimonial.text) {
      await addTestimonial(newTestimonial, file); // Pass the file to the method
      setNewTestimonial({ name: "", role: "", text: "", avatar: "" });
      setFile(null); // Reset the file input
    }
  };

  const handleUpdateTestimonial = async () => {
    if (editingTestimonial && newTestimonial.name && newTestimonial.text) {
      await updateTestimonial(editingTestimonial.id, newTestimonial, file); // Pass the file to the method
      setEditingTestimonial(null);
      setNewTestimonial({ name: "", role: "", text: "", avatar: "" });
      setFile(null); // Reset the file input
    }
  };

  const handleEdit = (testimonial) => {
    setEditingTestimonial(testimonial);
    setNewTestimonial({
      name: testimonial.name,
      role: testimonial.role,
      text: testimonial.text,
      avatar: testimonial.avatar,
    });
  };

  const handleDelete = async (id) => {
    if (
      await confirmDelete({
        title: "Delete Testimonial?",
        text: "This testimonial will be permanently deleted.",
      })
    ) {
      await deleteTestimonial(id);
      successToast("Testimonial deleted successfully.");
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Manage Testimonials</h2>

      {/* Add/Edit Form */}
      <div className="mb-6">
        <h3 className="text-xl font-semibold mb-2">
          {editingTestimonial ? "Edit Testimonial" : "Add New Testimonial"}
        </h3>
        <input
          type="text"
          name="name"
          placeholder="Name"
          value={newTestimonial.name}
          onChange={handleInputChange}
          className="block w-full mb-2 p-2 border rounded"
        />
        <input
          type="text"
          name="role"
          placeholder="Role"
          value={newTestimonial.role}
          onChange={handleInputChange}
          className="block w-full mb-2 p-2 border rounded"
        />
        <textarea
          name="text"
          placeholder="Testimonial Text"
          value={newTestimonial.text}
          onChange={handleInputChange}
          className="block w-full mb-2 p-2 border rounded"
        />
        <div className="mb-3">
          <ImageUploadField
            label="Avatar"
            hint="Recommended size: 200×200px (square)"
            aspect="square"
            previewUrl={newTestimonial.avatar}
            file={file}
            onChange={handleFileChange}
            onClear={() => setFile(null)}
          />
        </div>
        <button
          onClick={editingTestimonial ? handleUpdateTestimonial : handleAddTestimonial}
          className="px-4 py-2 bg-blue-500 text-white rounded"
        >
          {editingTestimonial ? "Update Testimonial" : "Add Testimonial"}
        </button>
        {editingTestimonial && (
          <button
            onClick={() => {
              setEditingTestimonial(null);
              setNewTestimonial({ name: "", role: "", text: "", avatar: "" });
              setFile(null); // Reset the file input
            }}
            className="ml-2 px-4 py-2 bg-gray-500 text-white rounded"
          >
            Cancel
          </button>
        )}
      </div>

      {/* Testimonials List */}
      <div>
        <h3 className="text-xl font-semibold mb-2">Testimonials</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="p-4 border rounded shadow">
              <img
                src={testimonial.avatar}
                alt={testimonial.name}
                className="w-full h-32 object-cover mb-2"
              />
              <h4 className="text-lg font-bold">{testimonial.name}</h4>
              <p className="text-sm text-gray-600">{testimonial.role}</p>
              <p className="text-sm text-gray-600">{testimonial.text}</p>
              <div className="mt-2 flex justify-between">
                <button
                  onClick={() => handleEdit(testimonial)}
                  className="px-3 py-1 bg-yellow-500 text-white rounded"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(testimonial.id)}
                  className="px-3 py-1 bg-red-500 text-white rounded"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}